import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/errorpage',
    name: 'Error',
    component: () => import(/* webpackChunkName: "about" */ '../views/Error.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/register.vue')
  },
  // 消息通知
  {
    path: '/adminmessage',
    name: 'adminMessage',
    component: () => import(/* webpackChunkName: "about" */ '../views/advice/adminMessage.vue')
  },
  {
    path: '/enterprisemessage',
    name: 'enterpriseMessage',
    component: () => import(/* webpackChunkName: "about" */ '../views/advice/enterpriseMessage.vue')
  },
  // 数据服务
  {
    path: '/patent/search',
    name: 'patentSearch',
    component: () => import(/* webpackChunkName: "about" */ '../views/dataService/patent/patentSearch.vue')
  },
  {
    path: '/patent/list',
    name: 'patentList',
    component: () => import(/* webpackChunkName: "about" */ '../views/dataService/patent/patentList.vue')
  },
  {
    path: '/brand/search',
    name: 'brandSearch',
    component: () => import(/* webpackChunkName: "about" */ '../views/dataService/brand/brandSearch.vue')
  },
  {
    path: '/brand/list',
    name: 'brandList',
    component: () => import(/* webpackChunkName: "about" */ '../views/dataService/brand/brandList1.vue')
  },
  {
    path: '/brand/detail',
    name: 'brandDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/dataService/brand/brandDetail1.vue')
  },
  // 商标高级检索
  {
    path: "/brand/advansearch",
    name: "brandAdvancedSearch",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/dataService/brand/brandAdvancedSearch.vue"
      ),
    meta: {
      keepAlive: true // 此组件需要被缓存
    }
  },
  {
    path: '/rankinglist/index',
    name: 'rankingListIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/dataService/rankingList/rankingListIndex.vue')
  },
  {
    path: '/monitor/index',
    name: 'monitorIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/dataService/monitorTrack/monitorIndex.vue')
  },
  {
    path: '/monitor/query',
    name: 'monitorQuery',
    component: () => import(/* webpackChunkName: "about" */ '../views/dataService/monitorTrack/monitorQuery.vue')
  },
  // 运营服务
  {
    path: '/requirement/index',
    name: 'requirementIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/operateService/requirementDocking/requirementIndex.vue')
  },
  // 发布新需求
  {
    path: '/requirement/apply',
    name: 'requirementApply',
    component: () => import(/* webpackChunkName: "about" */ '../views/operateService/requirementDocking/requirementApply.vue')
  },
  // 查看更多
  {
    path: '/requirement/financ',
    name: 'requirementFinanc',
    component: () => import(/* webpackChunkName: "about" */ '../views/operateService/requirementDocking/requirementFinanc.vue')
  },
  {
    path: '/serviceorg/index',
    name: 'serviceOrgIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/operateService/serviceOrg/serviceOrgIndex.vue')
  },
  // 融资服务
  {
    path: '/selftest/index',
    name: 'financingSelftestIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/financingService/selftest/financingSelftestIndex/financingSelftestIndex.vue')
  },
  {
    path: '/selftest/report',
    name: 'selfQuaEvalReport',
    component: () => import(/* webpackChunkName: "about" */ '../views/financingService/selftest/selfQuaEvalReport.vue')
  },
  {
    path: '/demand/index',
    name: 'demandIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/financingService/demand/demandIndex.vue')
  },
  {
    path: '/demand/apply',
    name: 'demandApply',
    component: () => import(/* webpackChunkName: "about" */ '../views/financingService/demand/demandApply.vue')
  },
  {
    path: '/demand/financ',
    name: 'demandFinanc',
    component: () => import('../views/financingService/demand/demandFinanc.vue')
  },
  {
    path: '/financing/serviceindex',
    name: 'serviceOrgIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/financingService/serviceOrg/serviceOrgIndex.vue')
  },
  // 智慧监管
  // 网络监管
  {
    path: '/network/index',
    name: 'networkIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/networkIndex.vue')
  },
  {
    path: '/network/overview',
    name: 'overview',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/overview.vue')
  },
  {
    path: '/network/enterpriseCollege',
    name: 'enterpriseCollege',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/enterpriseCollege.vue')
  },
  {
    path: '/network/talentExpert',
    name: 'talentExpert',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/talentExpert.vue')
  },
  {
    path: '/network/intellProperty',
    name: 'intellProperty',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/intellProperty.vue')
  },
  // 企业对比
  {
    path: '/network/enterpriseContrast',
    name: 'enterpriseContrast',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/enterpriseContrast/contrastIndex.vue')
  },
  // 报表
  {
    path: '/network/reportform',
    name: 'repeatForm',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/reportForm.vue'),
    meta: {
      keepAlive: true // 此组件需要被缓存
    }
  },
  // 生成报表
  {
    path: '/network/reportresult',
    name: 'repeatResult',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/reportResult/reportResult.vue')
  },
  // 对比
  {
    path: '/network/contrast',
    name: 'contrastIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/contrastIndex.vue'),
    meta: {
      keepAlive: true // 此组件需要被缓存
    }
  },
  // 对比结果
  {
    path: '/network/contrastresult',
    name: 'contrastResult',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/contrastResult/contrastResult.vue')
  },
  // 追踪
  {
    path: '/network/track',
    name: 'trackIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/trackIndex.vue')
  },
  // 榜单
  {
    path: '/network/rank',
    name: 'rankIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/network/rankIndex.vue')
  },
  // 侵权假冒监测
  {
    path: '/infringfake/index',
    name: 'infringFakeIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/wisdomRegulation/infringFake/infringFakeIndex.vue')
  },
  // 浏览电商产品
  {
    path: '/infringfake/financ',
    name: 'infringFinanc',
    component: () => import(/* webpackChunkName: "about" */'../views/wisdomRegulation/infringFake/infringFakeFinanc.vue')
  },
  // 帮助
  {
    path: '/help/guild',
    name: 'quickStartGuide',
    component: () => import(/* webpackChunkName: "about" */ '../views/help/quickStartGuide.vue')
  },
  {
    path: '/help/knownsearch',
    name: 'knownSearch',
    component: () => import(/* webpackChunkName: "about" */ '../views/help/knownSearch.vue')
  },
  {
    path: '/help/leaderboard',
    name: 'leaderBoard',
    component: () => import(/* webpackChunkName: "about" */ '../views/help/leaderBoard.vue')
  },
  {
    path: '/help/pledgeservice',
    name: 'pledgeService',
    component: () => import(/* webpackChunkName: "about" */ '../views/help/pledgeService.vue')
  },
  {
    path: '/help/intellsupervise',
    name: 'intellSupervise',
    component: () => import(/* webpackChunkName: "about" */ '../views/help/intellSupervise.vue')
  },
  // 用户部分
  // 用户信息
  {
    path: '/user/info',
    name: 'userInfo',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/userInfo.vue')
  },
  // 用户积分
  {
    path: '/user/integral',
    name: 'userIntegral',
    component: () => import('../views/user/userIntegral.vue')
  },
  // 用户服务
  {
    path: '/user/services',
    name: 'userService',
    component: () => import('../views/user/userService.vue')

  },
  // 管理员用户部分
  // 用户管理
  {
    path: '/adminUser/userTable',
    name: 'userTable',
    component: () => import('../views/admin/adminUser/userTable.vue')
  },
  // 修改用户
  {
    path: '/adminUser/revampUser',
    name: 'revampUser',
    component: () => import('../views/admin/adminUser/revampUser.vue')
  },
  // 查看用户
  {
    path: '/adminUser/checkUser',
    name: 'checkUser',
    component: () => import('../views/admin/adminUser/checkUser.vue')
  },
  // 积分管理
  {
    path: '/adminIntegral/integralTable',
    name: 'integralTable',
    component: () => import('../views/admin/adminIntegral/integralTable.vue')
  },
  // 管理积分详情
  {
    path: '/adminIntegral/integralDetails',
    name: 'integralDetails',
    component: () => import('../views/admin/adminIntegral/integralDetails.vue')
  },
  // 服务管理
  {
    path: '/adminServe/serveTable',
    name: 'serveTable',
    component: () => import('../views/admin/adminServe/serveTable.vue')
  },
  // 侵权管理
  {
    path: '/adminServe/serveTort',
    name: 'serveTort',
    component: () => import('../views/admin/adminServe/serveTort.vue')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
